module.exports = "pegasus_template/assets/blocks/header-8-theme5.png";